import React, { useEffect, useState, useContext, Fragment } from 'react'
import { Link } from 'gatsby'
import Grid from '@material-ui/core/Grid'
import Card from './Card'
import { retrieveCompletedBreaksFromLocalOrAPI } from 'services/break'
import { userContext } from 'global/context/sub-contexts/userContext'

const CardStructure = ({
  breaks,
  index = 0,
  isHighlight,
  showAll,
  tag,
  page,
  sectionTitle,
  viewMoreLink,
}) => {
  const [completedBreaks, updateCompletedBreaks] = useState([])
  const user_context = useContext(userContext)
  const { isLoggedIn } = user_context

  useEffect(() => {
    if (isLoggedIn()) {
      retrieveCompletedBreaks(breaks)
    } else {
      updateCompletedBreaks([])
    }
  }, [])

  const retrieveCompletedBreaks = async breaks => {
    try {
      const completedBrks = await retrieveCompletedBreaksFromLocalOrAPI(breaks)
      updateCompletedBreaks(completedBrks)
    } catch (e) {
      console.warn(e)
    }
  }

  const breakIsCompleted = breakId => {
    return completedBreaks && completedBreaks[breakId]
  }

  return (
    <section
      className={`cards cards--small ${isHighlight ? 'highlight' : ''}`}
      key={index || 0}
    >
      <div className="cards__intro">
        <div className="container">
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={6}>
              {sectionTitle && (
                <h3
                  className="headline"
                  style={{ textTransform: 'capitalize' }}
                >
                  {sectionTitle}
                </h3>
              )}
            </Grid>
            {breaks && breaks.length > 0 && !showAll && (
              <Grid item xs={6}>
                {tag && (
                  <Link
                    to={`/tag/${tag.toLowerCase()}`}
                    title="View all"
                    className="cards__intro-all"
                  >
                    View all
                  </Link>
                )}
                {viewMoreLink && (
                  <Link
                    to={viewMoreLink}
                    title="View all"
                    className="cards__intro-all"
                  >
                    View all
                  </Link>
                )}
              </Grid>
            )}
          </Grid>
        </div>
      </div>
      <div className="container">
        <Grid container spacing={2}>
          {breaks &&
            breaks.map((brk, index) => {
              return (
                <Fragment key={index}>
                  {showAll && (
                    <Grid item xs={6} sm={6} md={3} key={page + '-' + index}>
                      <Card
                        brk={brk}
                        breakIsCompleted={breakIsCompleted(brk.id)}
                      />
                    </Grid>
                  )}
                  {!showAll && index <= 3 && (
                    <Grid item xs={6} sm={6} md={3} key={page + '-' + index}>
                      <Card
                        brk={brk}
                        breakIsCompleted={breakIsCompleted(brk.id)}
                      />
                    </Grid>
                  )}
                </Fragment>
              )
            })}
        </Grid>
      </div>
    </section>
  )
}

export default CardStructure
